const industryList = [
	{
		name: "electronics",
		title: "Electronics",
		svgLine: "./images/industry-electronics-line.svg",
		svgFull: "./images/industry-electronics-full.svg"
	},
	{
		name: "fashion",
		title: "Fashion & Accessories",
		svgLine: "./images/industry-fashion-line.svg",
		svgFull: "./images/industry-fashion-full.svg"
	},
	{
		name: "beauty",
		title: "Health & Beauty",
		svgLine: "./images/industry-beauty-line.svg",
		svgFull: "./images/industry-beauty-full.svg"
	},
	{
		name: "home",
		title: "Home & Garden",
		svgLine: "./images/industry-home-line.svg",
		svgFull: "./images/industry-home-full.svg"
	},
	{
		name: "outdoors",
		title: "Sports & Outdoors",
		svgLine: "./images/industry-outdoors-line.svg",
		svgFull: "./images/industry-outdoors-full.svg"
	},
	{
		name: "food",
		title: "Food & Tobacco",
		svgLine: "./images/industry-food-line.svg",
		svgFull: "./images/industry-food-full.svg"
	},
	{
		name: "bedding",
		title: "Bedding & Bath",
		svgLine: "./images/industry-bedding-line.svg",
		svgFull: "./images/industry-bedding-full.svg"
	},
	{
		name: "footwear",
		title: "Footwear",
		svgLine: "./images/industry-footwear-line.svg",
		svgFull: "./images/industry-footwear-full.svg"
	}
];

export default industryList;
